/** Phase: hub/home empty-state copy — ko/en/vi/ru */

function pick(tuple, i) {
  return tuple[i];
}

function buildLang(langIndex) {
  const hubs = {
    emptyBusinesses: [
      '등록된 업체가 없습니다',
      'No businesses listed yet.',
      'Chưa có doanh nghiệp nào.',
      'Пока нет зарегистрированных заведений.',
    ],
    emptyCatalog: [
      '등록된 상품이 없습니다',
      'No products listed yet.',
      'Chưa có sản phẩm nào.',
      'Пока нет товаров.',
    ],
    unknownCategory: [
      '알 수 없는 카테고리입니다',
      'Unknown category.',
      'Danh mục không xác định.',
      'Неизвестная категория.',
    ],
    hubFallbackTitle: ['허브', 'Hub', 'Trung tâm', 'Хаб'],
    productsSectionTitle: ['인기 서비스', 'Popular services', 'Dịch vụ phổ biến', 'Популярные услуги'],
    businessesSectionTitle: ['업체', 'Businesses', 'Doanh nghiệp', 'Заведения'],
    businessCountLabel: ['{n}개 업체', '{n} businesses', '{n} doanh nghiệp', '{n} заведений'],
    allTab: ['전체', 'All', 'Tất cả', 'Все'],
    seoDesc: [
      '{title} — 현지 업체와 서비스를 찾아보세요.',
      '{title} — find local businesses and services.',
      '{title} — tìm cửa hàng và dịch vụ địa phương.',
      '{title} — местные заведения и услуги.',
    ],
  };

  const home = {
    newsEmpty: [
      '아직 뉴스가 없어요.',
      'No news yet.',
      'Chưa có tin tức.',
      'Пока нет новостей.',
    ],
  };

  return {
    hubs: Object.fromEntries(Object.entries(hubs).map(([k, v]) => [k, pick(v, langIndex)])),
    home: Object.fromEntries(Object.entries(home).map(([k, v]) => [k, pick(v, langIndex)])),
  };
}

export const phaseHubEmptyKo = buildLang(0);
export const phaseHubEmptyEn = buildLang(1);
export const phaseHubEmptyVi = buildLang(2);
export const phaseHubEmptyRu = buildLang(3);
